import type { WorkspaceDefinitions } from "@/components/workspace/definition"
import { teacherWorkspace } from "@/pages/educators/teacher-workspace"
import { schoolAdminWorkspace } from "@/pages/learners/school-admin-workspace"
import { studentWorkspace } from "@/pages/learners/student-workspace"

// The workspace definitions, one per owner type, as the shell receives them:
// the header's menu sections, the workspace pages' cards and every trail's
// root crumb read from here through WorkspaceDefinitionsContext. Each lives
// in its domain's tree; only this root knows all three.
export const workspaces: WorkspaceDefinitions = {
  teacher: teacherWorkspace,
  school_admin: schoolAdminWorkspace,
  student: studentWorkspace,
}
